import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import customEventBus from '@common/scripts/libs/eventBus';
import useMediaQueries from '@stone/hooks/useMediaQueries';
import { getZeroPadNumber } from '@common/utils/stringUtils';
import { siteUrl } from '@common/utils/urlutils';
import A11YMenuAccountBar from '@stone/components/a11y/A11YMenuAccountBar';
import ModalDrawer from '@stone/components/modal/ModalDrawer';
import { useLangChecker } from '@common/utils/i18n';
const AccountMenu = (props) => {
    const [wishlistCount, setWishlistCount] = useState(window.wishlistIds.length);
    // const [animateWishlistIcon, setAnimateWishlistIcon] = useState(false);
    const { t } = useTranslation();
    const { isMobile } = useMediaQueries();
    const accountModalTimeout = useRef();
    useEffect(() => {
        let animateTimeout;
        customEventBus.on('wishlist:update', (data) => {
            let adding = false;
            if (data === null || data === void 0 ? void 0 : data.wishlistIds) {
                if (data.wishlistIds.length > window.wishlistIds.length) {
                    // adding to wishlist
                    adding = true;
                }
                window.wishlistIds = data.wishlistIds;
                setWishlistCount(data.wishlistIds.length);
            }
            if (adding && !isMobile) {
                clearTimeout(animateTimeout);
            }
        });
    }, []);
    const openModal = () => {
        !window.loggedin ? props.handleModalOpen() : setModalOpened(true);
    };
    const handleModalOpen = (force) => {
        props.deactivateMenu();
        clearTimeout(accountModalTimeout.current);
        if (force) {
            return openModal();
        }
        accountModalTimeout.current = setTimeout(() => {
            openModal();
        }, 500);
    };
    const [modalOpened, setModalOpened] = useState(false);
    if (window.unshoppable)
        return React.createElement(React.Fragment, null);
    return (React.createElement(React.Fragment, null, !window.loggedin ? (React.createElement("button", { onClick: (e) => {
            handleModalOpen();
        }, className: "menu-heading", "aria-haspopup": "dialog" },
        React.createElement("span", null, t('label.login')))) : (React.createElement(React.Fragment, null,
        React.createElement("button", { onClick: (e) => {
                handleModalOpen();
            }, "aria-haspopup": "true", className: "menu-heading" },
            React.createElement("span", null,
                React.createElement("span", { ref: useLangChecker }, t('account.menumodal.profilename')),
                ` ${props.profileName}`)),
        React.createElement(ModalDrawer, { isOpen: modalOpened, onRequestClose: () => {
                setModalOpened(false);
            }, className: "accountmenu-drawer", a11yBar: React.createElement(A11YMenuAccountBar, null) },
            React.createElement("h3", { className: "accountmenu-drawer__title" },
                React.createElement("span", { ref: useLangChecker }, t('account.menumodal.profilename')),
                ` ${props.profileName}`),
            React.createElement("ul", { className: "accountmenu-drawer__menu" },
                React.createElement("li", { className: "accountmenu-drawer__item" },
                    React.createElement("a", { href: siteUrl('profile') }, t('profile.myprofile'))),
                React.createElement("li", { className: "accountmenu-drawer__item" },
                    React.createElement("a", { href: siteUrl('wishlist') },
                        React.createElement("span", { ref: useLangChecker }, t('label.wishlist')),
                        ` (${getZeroPadNumber(wishlistCount)})`)),
                React.createElement("li", { className: "accountmenu-drawer__item" },
                    React.createElement("a", { href: `${siteUrl('profile')}#addresses` }, t('profile.addressbook'))),
                React.createElement("li", { className: "accountmenu-drawer__item" },
                    React.createElement("a", { href: siteUrl('logout') }, t('label.signout')))))))));
};
export default AccountMenu;
